import React, { useState, useEffect } from 'react';
import CreateForm from '../../components/Campaigns/Page/CreateForm';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import useApiManager from '../../utils/Api/apiManager';

const CreateCampaign = () => {
    const navigate = useNavigate();
    const { post } = useApiManager();

    const handleFormSubmit = async (formData) => {
        //console.log('Form Submitted:', formData);
        // Handle form submission logic here (e.g., send data to an API)
        try {
            const responseData = await post('/campaigns', formData);
            if (responseData?.id) {
                navigate(`/campaigns/${responseData.id}`);
            }
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };

    const goBack = () => {
        navigate(-1); // -1 goes back in history, equivalent to history.goBack()
    };

    useEffect(() => {
        document.title = "Create Campaign - iLead CRM";
    }, []);

    return (
        <Box sx={{ p: 5 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <h3>Create Campaign</h3>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <Button variant="outlined" onClick={() => goBack()}>Cancel</Button>

                        <Button variant="contained" type="submit" form="create-form">Save</Button>
                    </Box>
                </Box>
                <Divider aria-hidden="true" sx={{ borderWidth: "thin" }} />
                <CreateForm onSubmit={handleFormSubmit} />
            </Paper >
        </Box>
    )
};

export default CreateCampaign;
